import { EventEmitter } from 'events';
import dispatcher from '../dispatchers/dispatcher';

class MagazineStore extends EventEmitter {
    constructor() {
        super();
        this.articles = [];
    }

    getArticles() {
        return this.articles;
    }

    handleActions(action) {
        switch (action.type) {
            case 'GET_ARTICLES': {
                action.articles.forEach((article) => {
                    this.articles.push(article);
                });
                this.emit('ARTICLES_RECEIVED');
                break;
            }
            case 'NO_NETWORK_CONNECTION': {
                this.emit('NO_NETWORK_CONNECTION');
                break;
            }
        }
    }
}

const magazineStore = new MagazineStore;
dispatcher.register(magazineStore.handleActions.bind(magazineStore));

export default magazineStore;


// WEBPACK FOOTER //
// ./src/stores/MagazineStore.js